module.exports = __webpack_public_path__ + "img/icon-person-active.b2fa34c4.png";